/* eslint-disable @typescript-eslint/only-throw-error -- redirect é o contrato do TanStack Router */
import { createFileRoute, redirect } from '@tanstack/react-router';

// Caminho antigo da aba no legado (`router.tsx:1367-1390`): o link salvo cai no detalhe com `?tab=` (S29).
export const Route = createFileRoute('/_app/gestao-carteira/carteiras/$walletId/arquivos-remessa')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/gestao-carteira/carteiras/$walletId', params, search: { tab: 'arquivos-remessa' }, replace: true });
  },
});
